import React, {Component} from "react";
import DefineApplicationStep from "./DefineApplicationStep";
import UploadStep from "./UploadStep";
import SuccessUploadStep from "./SuccessUploadStep";

const STEP_DEFINE_APPLICATION = 1;
const STEP_UPLOAD = 2;
const STEP_SUCCESS_UPLOAD = 3;

export default class Documents extends Component {
    constructor() {
        super(...arguments);

        this.state = {
            step: STEP_DEFINE_APPLICATION,
            applicationId: '',
            applicationStatus: '',
            fullName: '',
            phoneNumber: '',
            address: '',
            needDocuments: []
        }

        this.setApplicationData = this.setApplicationData.bind(this);
    }

    setApplicationData(applicationId, applicationStatus, fullName, phoneNumber, address, needDocuments) {
        this.setState({
            applicationId: applicationId,
            applicationStatus: applicationStatus,
            fullName: fullName,
            phoneNumber: phoneNumber,
            address: address,
            needDocuments: needDocuments
        })
    }

    render() {
        const {step, applicationId, applicationStatus, fullName, phoneNumber, address, needDocuments} = this.state;

        return (
            <div className="documents-wrapper">
                {step === STEP_DEFINE_APPLICATION &&
                <DefineApplicationStep
                    moveNext={() => this.setState({step: STEP_UPLOAD})}
                    setData={this.setApplicationData}
                />
                }
                {step === STEP_UPLOAD &&
                <UploadStep
                    applicationId={applicationId}
                    applicationStatus={applicationStatus}
                    fullName={fullName}
                    phoneNumber={phoneNumber}
                    address={address}
                    needDocuments={needDocuments}
                    moveNext={() => this.setState({step: STEP_SUCCESS_UPLOAD})}
                />
                }
                {step === STEP_SUCCESS_UPLOAD &&
                <SuccessUploadStep/>
                }
            </div>
        )
    }
}
